import api from '@/api/api';

export const dashboardEvents = {
  namespaced: true,
  state: {
    eventId: null,
    loading: false,
    error: false,
    isSidebarOpen: false,
    currentEvent: JSON.parse(localStorage.getItem('currentEvent')) || null,
    events: JSON.parse(localStorage.getItem('events')) || [],
    unverifiedEvents: JSON.parse(localStorage.getItem('unverifiedEvents')) || [],
    currency: 'PLN',
    currencies: [],
    totalPhotosInEvent: 0,
    //orders table
    ordersData: [],
    ordersLoading: false,
    ordersError: null,
    albumsTableItemCount: 0,
    albumViewsData: [],
    albumViewsLoading: false,
    albumViewsError: null,
    ordersTableItemCount: 0,
    totalOrganizatorCommission: 0,
    organizatorCommissionPerCurrency: 0,
    sponsorImage: null,
    globalSponsorImage: null,
    sponsorAssets: [],
    sponsorAssetsDashboardData: null,
    pagination: {
      totalPages: 1,
      currentPage: 1
    },
    links: [
      { icon: 'share', text: 'dashboard.menu.shares' },
      { icon: 'shopping_cart', text: 'dashboard.main.totalOrders' },
    ],
  },
  getters: {
    getCurrentEvent: (state) => {
      if (!state.currentEvent && state.eventId) {
        return (
          state.events.find((event) => event.id === parseInt(state.eventId)) || null
        );
      }
      return state.currentEvent;
    },
    getCurrency: (state) => state.currency,
    getCurrencies: (state) => state.currencies,
    isSidebarOpen: (state) => state.isSidebarOpen,
  },
  actions: {
    async fetchCurrencies({ commit }) {
      try {
        const response = await api.getCurrencies();
        if (response.data && response.data.data) {
          commit('setCurrencies', response.data.data);
        }
      } catch (error) {
        commit('setCurrencies', ['PLN']);
      }
    },
    async fetchUserEvents({ commit, rootState, dispatch }) {
      commit('setLoading', true);
      commit('setError', false);
      try {
        const userId = rootState.auth.user.id;

        const events = await api.getUserEvents(userId);
        const eventIds = events.data.data.map(event => event.id).join(',').trim();

        dispatch('fetchRpqEvents', eventIds);
        
        commit('setEvents', events.data.data);
      } catch (error) {
        commit('setEvents', []);
        commit('setError', true);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async fetchEventById({ commit, state, dispatch }, { eventId }) {
      commit('setLoading', true);
      commit("setError", false);
      try {
        dispatch('fetchTotalPhotosInEvent', { wpRunId: eventId });

        const currency = state.currency;

        const currentEvent = await api.getEventDetails(eventId, currency);
        const event = state.events.find((event) => event.id === parseInt(eventId));

        const combinedEventData = {
          ...event,
          ...currentEvent.data.data
        };

        commit('setCurrentEvent', combinedEventData);

        return combinedEventData
      } catch (error) {
        commit("setError", true);
        commit('setCurrentEvent', {});
      } finally {
        commit('setLoading', false);
      }
    },
    toggleSidebar({ commit }, isOpen) {
      commit('setSidebar', isOpen);
    },
    async fetchRpqEvents({ commit }, eventIds) {
      if (!eventIds) {
        return;
      }
      commit('setError', false);
      
      try {
        const response = await api.fetchRpqEvents(eventIds);
        commit('mergeEvents', response.data.data);
      } catch (error) {
        commit("setError", true);
      }
    },
    async fetchGlobalSponsorImage({ commit, rootState }) {
      commit('setError', false);
      
      try {
        if (rootState.auth.user.role !== 'sponsor') {
          return;
        }
        const userId = rootState.auth.user.id;

        const response = await api.fetchGlobalSponsorImage(userId);
        commit('setGlobalSponsorImage', response.data.data);
      } catch (error) {
        commit("setError", true);
      }
    },
    async fetchTotalPhotosInEvent({ commit }, { wpRunId }) {
      commit('setLoading', true);
      commit("setError", false);

      try {
        const response = await api.getTotalPhotosInEvent(parseInt(wpRunId));
        commit('setTotalPhotosInEvent', response.data.data.totalPhotosInRace);
      } catch (error) {
        commit("setError", true);
        commit('setTotalPhotosInEvent', 0);
      } finally {
        commit('setLoading', false);
      }
    },
    async fetchEventOrdersData({ commit, state }, { eventId, page, perPage }) {
      commit('setOrdersLoading', true);
      commit('setOrdersError', null);

      try {
        const response = await api.getEventOrdersTableData(eventId, page, perPage, state.currency);
        const responseData = response.data.data;

        const ordersData = responseData.orders || {};

        const totalTableItemsCount = responseData.totalItems || 0;
        const totalPages = responseData.totalPages || 0;
        const currentPage = responseData.currentPage || 1;

        commit('setOrdersData', Object.values(ordersData));
        commit('setTotalTableItemsCount', totalTableItemsCount);
        commit('setTotalOrganizatorCommission', responseData.totalOrganizatorCommission);
        commit('setOrganizatorCommissionPerCurrency', responseData.organizatorCommissionPerCurrency);
        commit('setPagination', { totalPages, currentPage });
      } catch (error) {
        commit('setOrdersError', error.message);
      } finally {
        commit('setOrdersLoading', false);
      }
    },
    async fetchEventAlbumViewsData({ commit }, { eventId, page, perPage, bibNumber }) {
      commit('setAlbumViewsLoading', true);
      commit('setAlbumViewsError', null);

      try {
        const response = await api.getAlbumViewsInEvent(eventId, page, perPage, bibNumber),
              responseData = response.data.data;

        const totalTableItemsCount = responseData.total || 0,
              totalPages = responseData.last_page || 0,
              currentPage = responseData.current_page || 1;

        commit('setAlbumViewsData', responseData);
        commit('setAlbumsTotalTableItemsCount', totalTableItemsCount);
        commit('setPagination', { totalPages, currentPage });
      } catch (error) {
        commit('setAlbumViewsError', error.message);
      } finally {
        commit('setAlbumViewsLoading', false);
      }
    },
    setCurrency({ commit }, currency) {
      commit('setCurrency', currency);
    },
    async createEventVerification({ commit, dispatch }, eventData) {
      commit('setLoading', true);
      commit('setError', false);

      try {
        const response = await api.createEventVerification(eventData);
        const newUnverifiedEvent = response.data.data;

        await dispatch('fetchUserUnverifiedEvents');
        await dispatch('fetchUserEvents');

        return newUnverifiedEvent;
      } catch (error) {
        commit('setError', true);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async fetchUserUnverifiedEvents({ commit, rootState }) {
      commit('setLoading', true);
      commit('setError', false);

      try {
        const userId = rootState.auth.user.id;

        const response = await api.getUserEventVerifications(userId);
        if (response.data && Array.isArray(response.data.data)) {
          const formattedUnverifiedEvents = response.data.data.map((event) => ({
            id: event.eventId,
            name: event.eventTitle,
            startDate: event.eventDate,
            eventCity: event.eventCity,
            eventStatus: 'unverified',
            thumbnail: event.landingImage,
            postAuthor: event.organizerId,
          }));
          commit('setUnverifiedEvents', formattedUnverifiedEvents);
        }
      } catch (error) {
        commit('setError', true);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async deleteEventVerification({ commit, state }, id) {
      commit('setLoading', true);
      commit('setError', false);

      try {
        const response = await api.deleteEventVerification(id);

        const updatedUnverifiedEvents = state.unverifiedEvents.filter(event => event.id !== id);
        commit('setUnverifiedEvents', updatedUnverifiedEvents);
        return response.data.data;
      } catch (error) {
        commit('setError', true);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async getEventFormData({ commit }, { action, eventId }) {
      commit('setLoading', true);
      commit('setError', false);

      try {
        let response;
        if (action === 'verification') {
          response = await api.getSingleEventVerification(eventId);
        } else if (action === 'event') {
          response = await api.getSingleEvent(eventId);
        }

        return response.data.data;
      } catch (error) {
        commit('setError', true);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async updateEvent({ commit, dispatch }, { action, eventId, eventData }) {
      commit('setLoading', true);
      commit('setError', false);

      try {
        let response;
        if (action === 'verification') {
          response = await api.updateEventVerification(eventId, eventData);
        } else if (action === 'event') {
          response = await api.updateEvent(eventId, eventData);
        }

        await dispatch('fetchUserUnverifiedEvents');
        await dispatch('fetchUserEvents');

        return response.data.data;
      } catch (error) {
        commit('setError', true);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async updateEventSponsorImage({ commit, dispatch }, { payload, eventId }) {
      commit('setLoading', true);
      commit('setError', false);

      try {
        const response = await api.updateEventSponsorImage(payload, eventId);

        await dispatch('fetchUserEvents');

        commit('setEventSponsorImage', response.data.data);
        return response.data.data;
      } catch (error) {
        commit('setError', true);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async setGlobalSponsorImage({ commit }, payload) {
      commit('setError', false);
      
      try {
        const response = await api.updateGlobalSponsorImage(payload);
        commit('setGlobalSponsorImage', response.data.data);
      } catch (error) {
        commit("setError", true);
        throw error;
      }
    },
    async fetchSponsorAssets({ commit }, wpRunId) {
      commit('setLoading', true);
      commit('setError', false);
      try {
        const response = await api.getSponsorAssets(wpRunId);
        commit('setSponsorAssets', response.data.data);
      } catch (error) {
        commit('setError', true);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async updateSponsorAssets({ commit, dispatch }, { eventId, data }) {
      commit('setLoading', true);
      commit('setError', false);
      try {
        const response = await api.updateSponsorAssets(data, eventId);
        
        await dispatch('fetchSponsorAssets', eventId);
        
        return response.data.data;
      } catch (error) {
        commit('setError', true);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async deleteSponsorAsset({ commit, dispatch }, { assetId, eventId }) {
      commit('setLoading', true);
      commit('setError', false);
      try {
        await api.deleteSponsorAsset(assetId);
        await dispatch('fetchSponsorAssets', eventId);
      } catch (error) {
        commit('setError', true);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async fetchSponsorAssetsDashboardData({ commit }, eventId) {
      commit('setLoading', true);
      commit('setError', false);
      try {
        const response = await api.getSponsorAssetsDashboardData(eventId);
        commit('setSponsorAssetsDashboardData', response.data.data);
      } catch (error) {
        commit('setError', true);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
  },
  mutations: {
    mergeEvents(state, rpqEvents){
      const events = state.events.map(event => {
        const rpqEvent = rpqEvents.find(rpqEvent => rpqEvent.wp_run_id === event.id);

        if (rpqEvent) {
          event.sponsor_image = rpqEvent.sponsor_image;
        }

        return event;
      })

      localStorage.setItem('events', JSON.stringify(events));
    },
    setGlobalSponsorImage(state, globalSponsorImage) {
      state.globalSponsorImage = globalSponsorImage;
    },
    setEventSponsorImage(state, eventSponsorImage) {
      state.eventSponsorImage = eventSponsorImage;
    },
    setSponsorAssets(state, assets) {
      state.sponsorAssets = assets;
    },
    setSponsorAssetsDashboardData(state, data) {
      state.sponsorAssetsDashboardData = data;
    },
    setSponsorImage(state, sponsorImage) {
      state.sponsorImage = sponsorImage;
    },
    setEvents(state, events) {
      state.events = events || [];
      localStorage.setItem('events', JSON.stringify(state.events));
    },
    setUnverifiedEvents(state, unverifiedEvents) {
      state.unverifiedEvents = unverifiedEvents || [];
      localStorage.setItem('unverifiedEvents', JSON.stringify(state.unverifiedEvents));
    },
    setCurrentEvent(state, currentEvent) {
      state.currentEvent = currentEvent;
      localStorage.setItem('currentEvent', JSON.stringify(currentEvent));
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    setSidebar(state, isOpen) {
      state.isSidebarOpen = isOpen;
    },
    setOrdersData(state, data) {
      state.ordersData = data;
    },
    setOrdersLoading(state, loading) {
      state.ordersLoading = loading;
    },
    setOrdersError(state, error) {
      state.ordersError = error;
    },
    setAlbumsPagination(state, pagination) {
      state.albumsPagination = pagination;
    },
    setAlbumsTotalTableItemsCount(state, itemsCount) {
      state.albumsTableItemCount = itemsCount;
    },
    setAlbumViewsData(state, data) {
      state.albumViewsData = data;
    },
    setAlbumViewsLoading(state, loading) {
      state.albumViewsLoading = loading;
    },
    setAlbumViewsError(state, error) {
      state.albumViewsError = error;
    },
    setTotalTableItemsCount(state, itemsCount) {
      state.ordersTableItemCount = itemsCount;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    setCurrency(state, currency) {
      state.currency = currency;
    },
    setCurrencies(state, currencies) {
      state.currencies = currencies;
    },
    setTotalOrganizatorCommission(state, totalOrganizatorCommission) {
      state.totalOrganizatorCommission = totalOrganizatorCommission;
    },
    setOrganizatorCommissionPerCurrency(state, organizatorCommissionPerCurrency) {
      state.organizatorCommissionPerCurrency = organizatorCommissionPerCurrency;
    },
    setTotalPhotosInEvent(state, data) {
      state.totalPhotosInEvent = data;
    },
  },
};
